import type { Pagination } from '@/lib/api/types'

export const emptyPagination = (): Pagination => ({
  current_page: 1,
  next_page: null,
  prev_page: null,
  total_pages: 1,
  total_count: 0,
  per_page: 15,
  more: false,
})
